<mat-toolbar class="mat-elevation-z1" color="primary">
  <!-- todo research why *transloco directive not work here -->
  <mat-toolbar-row class="crm-layout-width">
    <div class="logo">
      <a mat-button routerLink="/">{{ 'header.crm' | transloco }}</a>
    </div>

    <crm-header-menu></crm-header-menu>

    <span class="crm-spacer"></span>

    <crm-operator-statuses></crm-operator-statuses>

    <crm-change-logs-widget class="header-badge"></crm-change-logs-widget>

    <crm-whatsapp-notifier class="header-badge"></crm-whatsapp-notifier>

    <crm-mail-notifier-top-header class="header-badge"></crm-mail-notifier-top-header>

    <crm-vimbot-notifier-top-header class="header-badge"></crm-vimbot-notifier-top-header>

    <crm-header-lang-select></crm-header-lang-select>

    <ng-container *ngIf="user">
      <button
        mat-button
        [matMenuTriggerFor]="userMenu"
        type="button"
        [title]="'header.id' | transloco : { id: user.id }"
      >
        <mat-icon class="account-badge">account_circle</mat-icon>
        {{ user.name }}
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <a mat-menu-item routerLink="/user/logout">{{ 'header.logout' | transloco }}</a>
      </mat-menu>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar>
